import { useState } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { HealthAndSafety, InfoOutlined, NotificationsActive, Rule } from '@mui/icons-material';
import { TableTitleBox } from '../../common/components';
import { HealthPanel } from './components/HealthPanel';
import { Inbox } from './components/Inbox';
import { JobRunsTable } from './components/JobRunsTable';
import { RulesTable } from './components/RulesTable';

const NotificationsCenter = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <TableTitleBox title="Administración | Notificaciones" />
      <Paper elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="scrollable">
          <Tab icon={<NotificationsActive />} iconPosition="start" label="Bandeja" />
          <Tab icon={<Rule />} iconPosition="start" label="Reglas" />
          <Tab icon={<InfoOutlined />} iconPosition="start" label="Ejecuciones" />
          <Tab icon={<HealthAndSafety />} iconPosition="start" label="Salud" />
        </Tabs>
      </Paper>
      <Box sx={{ bgcolor: 'background.paper', p: 2 }}>
        {tab === 0 && <Inbox />}
        {tab === 1 && <RulesTable />}
        {tab === 2 && <JobRunsTable />}
        {tab === 3 && <HealthPanel />}
      </Box>
    </Box>
  );
};

export default NotificationsCenter;
